<template>
  <ValidationProvider
    :rules="{ required: !!customErrorMsg }"
    name="adequacy_form"
    ref="formWrapper"
    class="w-100 d-flex flex-wrap align-items-start"
  >
    <div class="col-3">
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
        ref="adequacyProvider"
        name="la adecuación"
      >
        <CustomDropDown
          v-model="model.adequacy"
          label="Adecuación:"
          :options="adequacyOptions"
          fieldkey="id"
          fieldname="spaShortDescription"
          placeholder="Seleccione"
          :error="errors[0]"
          custom-error-msg="Campo es requerido"
        />
      </ValidationProvider>
    </div>
    <template v-if="!!model.adequacy">
      <div class="col-3" style="padding-top: 27px;">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required"
          ref="measure1Amt"
        >
          <CustomInput
            v-model="model.measure1Amt"
            type="number"
            :error="errors[0]"
            custom-error-msg="Campo es requerido"
          />
        </ValidationProvider>
      </div>

      <div
        class="d-flex align-items-center justify-content-center"
        style="padding-top: 30px;margin-left: -8px;margin-right: -8px;"
      >
        {{ isAttemps ? 'de' : '%' }}
      </div>

      <div v-if="isAttemps" class="col-3" style="padding-top: 27px;">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required"
          ref="measure2Amt"
        >
          <CustomInput
            v-model="model.measure2Amt"
            type="number"
            :error="errors[0]"
            custom-error-msg="Campo es requerido"
          />
        </ValidationProvider>
      </div>
    </template>
    <div v-if="!!customErrorMsg" class="col-12">
      <Error class="mt-2" variant="no-border" :message="customErrorMsg" />
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import GoalMeasures from '@/utils/constants/pei/peiGoalMeasures';
import CustomTextarea from '@/components/common/CustomTextArea';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import Error from '@/components/common/Error';

export default {
  name: 'AdequacyForm',
  components: {
    CustomTextarea,
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    Error,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        adequacy: null,
        measure1Amt: null,
        measure2Amt: null,
      }),
    },
    adequacyOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        adequacy: null,
        measure1Amt: null,
        measure2Amt: null,
      },
    };
  },
  methods: {},
  computed: {
    isAttemps() {
      return this.model.adequacy?.id == GoalMeasures.attempts;
    },
    customErrorMsg() {
      const measure1Amt = parseInt(this.model.measure1Amt);
      const measure2Amt = parseInt(this.model.measure2Amt);
      if (
        !this.isAttemps &&
        !isNaN(measure1Amt) &&
        (measure1Amt < 1 || measure1Amt > 100)
      )
        return 'El porcentaje debe ser mayor o igual a 1 y menor o igual a 100';

      if (
        this.isAttemps &&
        !isNaN(measure1Amt) &&
        !isNaN(measure2Amt) &&
        measure1Amt > measure2Amt
      )
        return 'El valor de los intentos no puede ser mayor que el total de intentos';

      return '';
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (
          !newValue ||
          (this.model.adequacy === newValue.adequacy &&
            this.model.measure1Amt === newValue.measure1Amt &&
            this.model.measure2Amt === newValue.measure2Amt)
        )
          return; // No hacer nada si no hay cambio real

        this.model = {
          adequacy: !!newValue?.adequacy ? { ...newValue.adequacy } : null,
          measure1Amt: newValue.measure1Amt || null,
          measure2Amt: newValue.measure2Amt || null,
        };
      },
    },
    model: {
      deep: true,
      handler(newValue) {
        this.$emit('input', { ...newValue });
      },
    },
    customErrorMsg(newVal) {
      const errors = !!newVal ? [newVal] : [];
      this.$refs.formWrapper.setErrors(errors);
    },
  },
};
</script>

<style>
.objetive-actions__container {
  display: flex;
  justify-content: flex-end;
}
</style>
